import { type UnitLabelType, type UnitsResponse } from './types';

export function mapUnitsI18nObject(
  data: UnitsResponse,
): Record<string, UnitsResponse['units'][string]>;

export function mapUnitsI18nObject(
  data: UnitsResponse,
  label: UnitLabelType,
): Record<string, string>;

/**
 * Select function for returning an object with the units and their related translations in the language of the user.
 */
export function mapUnitsI18nObject(data: UnitsResponse, label?: UnitLabelType) {
  return Object.fromEntries(
    Object.entries(data.units).map(([key, value]) => [
      key.toUpperCase(),
      label ? value[label] : value,
    ]),
  );
}
